import { combineReducers } from 'redux';

import { globalSlice } from 'src/pages/_redux/global/globalsSlice';
import { socketSlice } from 'src/pages/_redux/socket/socketSlice';
import { userSlice } from 'src/pages/_redux/user/usersSlice';
import { derivativePageSlice } from 'src/pages/derivatives/_redux/derivativePageSlice';
import { spotPageSlice } from 'src/pages/spot/_redux/spotPageSlice';

export const rootReducer = combineReducers({
    socket: socketSlice.reducer,
    globalData: globalSlice.reducer,
    derivativePage: derivativePageSlice.reducer,
    userData: userSlice.reducer,
    spotPage: spotPageSlice.reducer,
});
